import { render, staticRenderFns } from "./QRDialog.vue?vue&type=template&id=42c88074&scoped=true"
import script from "./QRDialog.vue?vue&type=script&lang=js"
export * from "./QRDialog.vue?vue&type=script&lang=js"
import style0 from "./QRDialog.vue?vue&type=style&index=0&id=42c88074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c88074",
  null
  
)

export default component.exports